import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';

interface ListItemCheckboxSignature<T> {
  Args: {
    isDisabled?: boolean;
    item: T;
    selectedItems: T[];
    userToggleChecked: (item: T, event: MouseEvent, checked: boolean) => unknown;
  };
  Element: HTMLInputElement;
}

export default class ListItemCheckbox<T> extends Component<ListItemCheckboxSignature<T>> {
  get isSelected(): boolean {
    return this.args.selectedItems.includes(this.args.item);
  }

  @action
  didClick(event: MouseEvent): void {
    const checkbox = event.target as HTMLInputElement;
    this.args.userToggleChecked(this.args.item, event, checkbox.checked);
  }

  <template>
    <input
      type="checkbox"
      {{on "click" this.didClick}}
      checked={{this.isSelected}}
      disabled={{@isDisabled}}
      data-test-entry-checkbox
      ...attributes
    />
  </template>
}
